import Vapi from '@vapi-ai/web';

declare global {
  interface Window {
    vapiInstance: any;
  }
}

export function initializeVapi(apiKey: string, assistantId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      console.log('Initializing VAPI with:', { hasApiKey: !!apiKey, assistantId });
      
      const vapi = new Vapi(apiKey);
      window.vapiInstance = vapi;

      // Set up event listeners
      vapi.on('call-start', () => {
        console.log('Call started');
        // Check if this is a phone call
        if (vapi.callType === 'phone') {
          updatePhoneCallCount();
        }
      });

      const updatePhoneCallCount = async () => {
        try {
          const { error } = await window.supabase
            .from('interviewers')
            .update({ 
              phone_calls_count: interviewer.phone_calls_count + 1,
              last_active: new Date().toISOString()
            })
            .eq('id', interviewer.id);

          if (error) throw error;
        } catch (err) {
          console.error('Failed to update phone call count:', err);
        }
      };

      vapi.on('call-end', () => {
        console.log('Call ended');
      });

      vapi.on('speech-start', () => {
        console.log('Speech started');
      });

      vapi.on('speech-end', () => {
        console.log('Speech ended');
      });

      vapi.on('volume-level', (volume) => {
        console.log('Volume level:', volume);
      });

      vapi.on('message', (message) => {
        console.log('Message received:', message);
      });

      vapi.on('error', (error) => {
        console.error('VAPI error:', error);
        reject(error);
      });

      resolve(vapi);
    } catch (error) {
      console.error('Failed to initialize VAPI:', error);
      reject(error);
    }
  });
}